import { useQuery } from '@tanstack/react-query';
import { supabase } from '../utils/supabaseClient';
import { queryKeys } from '../utils/queryKeys';

const primaryCategories = [
    { id: 1, name: "Discover", path: "discover" },
    { id: 2, name: "Trending", path: "trending" },
    { id: 3, name: "Just In", path: "just_in" },
    { id: 4, name: "Launched", path: "launched" },
];

const fetchCategoryAssets = async () => {
    // IDs de los assets para los diferentes tamaños de texto
    const assets = [
        // 1-3 caracteres
        { length: '1-3', id: '1d8817f6-a150-429e-9117-326217d5a09e' },
        // 4-5 caracteres
        { length: '4-5', id: '01b1f155-494f-4bd5-8b76-fa17ef6cbd96' },
        // 6-7 caracteres
        { length: '6-7', id: '60ba5b7a-df4b-4c80-b876-a5cf2c432ebf' },
        // 8-9 caracteres
        { length: '8-9', id: 'f429ba09-1f9d-454a-a771-8d4df609df06' },
        // 10-11 caracteres
        { length: '10-11', id: '48144b86-a47d-4109-af36-506a46643742' },
        // 12 caracteres
        { length: '12', id: 'cd8fd859-d930-4caa-8369-2765d6d139ad' },
        // 13 caracteres
        { length: '13', id: '34fa3345-d057-4e63-b027-4137fb3ff5ba' },
        // 14-15 caracteres
        { length: '14-15', id: 'd8440a03-ec78-491a-810a-40089521536f' },
        // 16+ caracteres
        { length: '16+', id: 'c5ede832-c816-4c26-a693-be8436149302' }
    ];

    const { data, error } = await supabase
        .from("assets")
        .select("id, link")
        .in("id", assets.map(asset => asset.id));

    if (error) throw error;

    // Convertir el resultado en un objeto para fácil acceso
    return data.reduce((acc, asset) => {
        acc[asset.id] = asset.link;
        return acc;
    }, {});
};

export function usePrimaryCategories() {
    const { data: imageLinks = {}, error } = useQuery({
        queryKey: queryKeys.assets.byType('category-icons'),
        queryFn: fetchCategoryAssets,
        staleTime: 1000 * 60 * 60, // 1 hora
        cacheTime: 1000 * 60 * 60 * 24, // 24 horas
    });

    const getImageIdByLength = (length) => {
        if (length >= 1 && length <= 3) return "1d8817f6-a150-429e-9117-326217d5a09e";
        if (length >= 4 && length <= 5) return "01b1f155-494f-4bd5-8b76-fa17ef6cbd96";
        if (length >= 6 && length <= 7) return "60ba5b7a-df4b-4c80-b876-a5cf2c432ebf";
        if (length >= 8 && length <= 9) return "f429ba09-1f9d-454a-a771-8d4df609df06";
        if (length >= 10 && length <= 11) return "48144b86-a47d-4109-af36-506a46643742";
        if (length === 12) return "cd8fd859-d930-4caa-8369-2765d6d139ad";
        if (length === 13) return "34fa3345-d057-4e63-b027-4137fb3ff5ba";
        if (length >= 14 && length <= 15) return "d8440a03-ec78-491a-810a-40089521536f";
        if (length >= 16) return "c5ede832-c816-4c26-a693-be8436149302";
        return "f429ba09-1f9d-454a-a771-8d4df609df06"; // Default ID
    };

    return {
        categories: primaryCategories,
        imageLinks,
        getImageIdByLength,
        error,
    };
}